<template>
    <span>
        <el-button type="text" @click="dialogFormVisible = true">管理显示列<i class="el-icon-setting"></i></el-button>
        <el-dialog title="管理显示列" :visible.sync="dialogFormVisible" center>
            <el-form ref="form" :model="form" size="small" status-icon>
                <el-form-item prop="check_all">
                    <el-checkbox :indeterminate="isIndeterminate" v-model="check_all" @change="handleCheckAllChange">全选</el-checkbox>
                </el-form-item>
                <el-form-item prop="table_fields">
                    <el-checkbox-group v-model="form.table_fields" @change="handleCheckedFieldsChange">
                        <el-checkbox v-for="(item, key) in list" :label="item.field" :key="key">{{item.label}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm('form')" :loading="loading">保 存</el-button>
            </div>
        </el-dialog>
    </span>
</template>
<style scoped>
/* 仅应用于当前组件的样式 */
</style>
<script>
import UserPathConfigService from '~/services/UserPathConfig';
export default {
    name: "TableFields",
    
    components: {
    },

    props: {
        path: {
            type: String,
            required: true,
        },
        tab: {
            type: String,
            required: true,
        },
        fields: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            //定义变量
            loading: false,
            dialogFormVisible: false,
            form: {
                table_fields: [],
                path: this.path,
                tab: this.tab,
            },
            rules: {
                table_fields: [
                    {required: true, message: "请选择显示列", trigger: "blur"}
                ],
            },
            check_all: false,
            list: [],
            isIndeterminate: false
        };
    },

    created() {
        this.list = this.fields;
        this.getView();
    },

    methods: {
        getView(){
            UserPathConfigService.getView({
                path: this.path,
                tab: this.tab,
            }).then(res => {
                if (res.code == 0 && res.data){
                    this.form = res.data;
                    // console.log('查询结果：', this.form);
                    this.handleCheckedFieldsChange(this.form.table_fields)
                }else{
                    this.handleCheckAllChange(true);
                }
                
            });
        },
        
        getValue(value, field) {
            this.form[field] = value;
        },

        submitForm(formName){
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.loading = true;
                    // console.log('submitForm：', this.form, this.form.id ? true : false);
                    let servcie;
                    if(this.form.id){
                        servcie = UserPathConfigService.update(this.form);
                    }else{
                        servcie = UserPathConfigService.create(this.form);
                    }
                    servcie.then(res => {
                        if (res.code == 0 && res.data){
                            this.$message({
                                message: "操作成功",
                                type: "success"
                            });
                            this.form.id = res.data.id;
                        }
                        this.loading = false;
                        this.dialogFormVisible = false;
                    }).catch((err) => {
                        console.error(err);
                        this.loading = false;
                    });
                } else {
                    return false;
                }
            });
        },

        handleCheckAllChange(value) {
            const all_field = this.list.map(item => item.field)
            this.form.table_fields = value ? all_field : [];
            this.isIndeterminate = false;
            this.check_all = this.form.table_fields.length === this.list.length;
            this.$emit("change", this.form.table_fields);
        },

        handleCheckedFieldsChange(value) {
            // console.log(value);
            let checkedCount = value.length;
            this.check_all = checkedCount === this.list.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.list.length;
            this.$emit("change", value);
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/widgets/TableFields.vue